import React from "react";

import {
  Box,
  Paper,
  Typography,
  Button,
  Alert,
  Divider,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

import HeaderMenu from "../Header/HeaderMenu";

import useGuestManage from "./useGuestManage";
import FilterSection from "./FilterSection";
import GuestEntryCard from "./GuestEntryCard";
import SummarySection from "./SummarySection";
import DeleteDialog from "./DeleteDialog";

const TemporaryMessStay = () => {
  const guest = useGuestManage();

const selectedHostelObj = (guest.hostelList || []).find(
  (hostel) =>
    String(hostel.id) === String(guest.selectedHostel) ||
    hostel.hostelName === guest.selectedHostel
);

const hostelId = selectedHostelObj?.id;

console.log("Selected hostel value:", guest.selectedHostel);
console.log("Matched hostel:", selectedHostelObj);
console.log("Resolved hostel ID:", hostelId);

  return (
    <>
      <HeaderMenu />

      <Box
        sx={{
          minHeight: "100vh",
          background:
            "linear-gradient(180deg, #f5f8fc 0%, #eef2f7 100%)",
          py: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1250,
            mx: "auto",
            px: { xs: 1.5, sm: 2.5, md: 3 },
          }}
        >
          {/* ================= HEADER ================= */}

          <Paper
            elevation={0}
            sx={{
              px: { xs: 2, sm: 3, md: 4 },
              py: { xs: 2, sm: 2.5 },
              mb: 2.5,
              borderRadius: 3,
              color: "#fff",
              background:
                "linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)",
              boxShadow:
                "0 8px 24px rgba(25, 118, 210, 0.18)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(255,255,255,0.18)",
                  flexShrink: 0,
                }}
              >
                <ReceiptLongIcon />
              </Box>

              <Box>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{
                    fontSize: {
                      xs: "1rem",
                      sm: "1.15rem",
                    },
                  }}
                >
                  Short-Term Guest Billingddd
                </Typography>

                <Typography
                  sx={{
                    mt: 0.3,
                    fontSize: {
                      xs: 11,
                      sm: 13,
                    },
                    opacity: 0.9,
                  }}
                >
                  Manage daily stay, mess usage and combined
                  guest services
                </Typography>
              </Box>
            </Box>
          </Paper>

          {/* ================= ERROR ================= */}

          {guest.errorMsg && (
            <Alert
              severity="error"
              sx={{
                mb: 2,
                borderRadius: 2,
              }}
              onClose={() => guest.setErrorMsg("")}
            >
              {guest.errorMsg}
            </Alert>
          )}

          {/* ================= SUCCESS ================= */}

          {guest.successMsg && (
            <Alert
              severity="success"
              sx={{
                mb: 2,
                borderRadius: 2,
              }}
              onClose={() => guest.setSuccessMsg("")}
            >
              {guest.successMsg}
            </Alert>
          )}

          {/* ================= FILTER ================= */}

          <FilterSection
            filter={guest.filter}
            setFilter={guest.setFilter}
            hostelList={guest.hostelList}
            selectedHostel={guest.selectedHostel}
            setSelectedHostel={guest.setSelectedHostel}
            handleSearch={guest.handleSearch}
            setRows={guest.setRows}
            setSearchTriggered={guest.setSearchTriggered}
          />

          {/* ================= ENTRY AREA ================= */}

          <Paper
            elevation={0}
            sx={{
              p: {
                xs: 1.5,
                sm: 2,
                md: 2.5,
              },
              borderRadius: 3,
              border: "1px solid #e2e8f0",
              background: "#fff",
              boxShadow:
                "0 4px 18px rgba(15, 23, 42, 0.05)",
            }}
          >
            {/* ENTRY HEADER */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                mb: 2,
              }}
            >
              <Box>
                <Typography
                  fontWeight={700}
                  color="#1e293b"
                >
                  Guest Billing Entries
                </Typography>

                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  Add and manage guest stay and mess
                  billing details
                </Typography>
              </Box>

              {guest.rows.length > 0 && (
                <Typography
                  variant="body2"
                  fontWeight={600}
                  color="primary"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {guest.rows.length}{" "}
                  {guest.rows.length === 1
                    ? "Entry"
                    : "Entries"}
                </Typography>
              )}
            </Box>

            <Divider sx={{ mb: 2 }} />

            {/* ================= ROWS ================= */}
          {guest.rows.length > 0 ? (
  guest.rows.map((row, index) => {
    
    return (
     <GuestEntryCard
  key={row.id || index}
  index={index}
  row={row}
  hostelId={hostelId}
  roomTypes={guest.roomTypes}
  hostelRoomDTOs={guest.roomPrices || []}
  rows={guest.rows}
  handleChange={guest.handleChange}
  handleSaveRow={guest.handleSaveRow}
  handlePrint={guest.handlePrint}
  handleWhatsApp={guest.handleWhatsApp}
  setRows={guest.setRows}
  setRowToDelete={guest.setRowToDelete}
  setOpenDeleteDialog={guest.setOpenDeleteDialog}
  isReadOnly={false}
  isDateOnlyEdit={false}
  isFullOccupancyEdit={false}
  showPrintActions={true}
  showWhatsAppActions={true}
  showDeleteActions={true}
/>
    );
  })
) : (
              /* ================= EMPTY STATE ================= */

              <Box
                sx={{
                  py: {
                    xs: 5,
                    sm: 6,
                  },
                  px: 2,
                  textAlign: "center",
                  border: "1px dashed #cbd5e1",
                  borderRadius: 3,
                  background: "#f8fafc",
                }}
              >
                <ReceiptLongIcon
                  sx={{
                    fontSize: 42,
                    color: "#94a3b8",
                    mb: 1,
                  }}
                />

                <Typography
                  fontWeight={600}
                  color="#475569"
                >
                  No billing entries
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 0.5 }}
                >
                  Search for a property and billing period
                  to begin.
                </Typography>
              </Box>
            )}

            {/* ================= ADD ENTRY ================= */}

            <Button
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}
              onClick={guest.addRow}
              disabled={
                !guest.searchTriggered ||
                guest.rows.some(
                  (r) => !r.isSaved
                )
              }
              sx={{
                mt: 2,
                py: 1.25,
                borderRadius: 2,
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "none",

                "&:hover": {
                  boxShadow:
                    "0 4px 12px rgba(25,118,210,0.2)",
                },
              }}
            >
              Add New Entry
            </Button>

            {/* ================= SUMMARY ================= */}

            {guest.rows.length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }} />

                <SummarySection
                  total={guest.totalAmount()}
                  received={guest.totalReceived()}
                  balance={guest.totalBalance()}
                />
              </Box>
            )}
          </Paper>
        </Box>
      </Box>

      {/* ================= DELETE CONFIRMATION ================= */}

      <DeleteDialog
        open={guest.openDeleteDialog}
        row={guest.rowToDelete}
        onClose={() =>
          guest.setOpenDeleteDialog(false)
        }
        onConfirm={guest.confirmDelete}
      />
    </>
  );
};

export default TemporaryMessStay;